import React, { Component } from 'react';

import { addCircleOutline as add, closeOutline as close } from 'ionicons/icons';
import {
  withIonLifeCycle,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonText,
  IonModal,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonContent,
  IonCheckbox,
  IonFooter,
  IonBackButton,
  IonImg,
  IonInput,
  IonToggle,
  IonTextarea,
  IonButton,
} from '@ionic/react';

import File from '../File/File';
import FiscalCodeService from '../../services/fiscalcode';
import PrescriptionRequestService from '../../services/prescriptionRequest';
import ProfileService from '../../services/profile';

class PrescriptionRequestForm extends Component {
  constructor(props) {
    super(props);

    this.form = React.createRef();
    this.nre = React.createRef();
    this.files = React.createRef();

    this.state = {
      type: this.props.type,
      nre: undefined,
      fse_consent: false,
      codice_fiscale: undefined,
      fiscalCodes: [],
      note: undefined,
      equivalent: false,
      fiscalcodeModal: false,
      files: [],
      errors: {},
      disabled: true,
    };

    this.fileHandler = this.fileHandler.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.inputHandler = this.inputHandler.bind(this);
    this.textHandler = this.textHandler.bind(this);
    this.toggleHandler = this.toggleHandler.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.handleFormValidation = this.handleFormValidation.bind(this);
    this.getUser = this.getUser.bind(this);
    this.getFiscalCodes = this.getFiscalCodes.bind(this);
    this.setFiscalCode = this.setFiscalCode.bind(this);
    this.submitRequest = this.submitRequest.bind(this);
  }

  async ionViewWillEnter() {
    await this.getUser();
    await this.getFiscalCodes();
    this.setState({
      nre: undefined,
      fse_consent: false,
      note: undefined,
      equivalent: false,
      codice_fiscale: undefined,
      files: [],
      errors: {},
      disabled: true,
    });
  }

  async getUser() {
    try {
      const {
        data: { data: profile },
      } = await ProfileService.me();

      this.setState({ fiscalCodes: { codice_fiscale: profile.codice_fiscale, id: 0, user: profile } });
    } catch (error) {
      console.error(error);
    }
  }

  async getFiscalCodes() {
    try {
      let {
        data: { data: fiscalCodes },
      } = await FiscalCodeService.get();

      fiscalCodes.push(this.state.fiscalCodes);
      this.setState({ fiscalCodes });
    } catch (error) {
      console.error(error);
    }
  }

  async fileHandler(files, event) {
    await this.setState({ files });
    await this.handleValidation(event);
    await this.handleFormValidation();
  }

  async removeFile(key) {
    let files = this.state.files;
    files = files.filter((f, i) => i !== key);
    this.setState({ files });

    if (this.files.current && this.files.current.input && this.files.current.input.current) {
      this.files.current.input.current.value = '';
    }

    await this.handleFormValidation();
  }

  async inputHandler(event) {
    let errors = this.state.errors;
    delete errors[event.target.name];

    await this.setState({
      [event.target.name]: event.target.value,
      errors,
    });

    await this.handleValidation(event);
    await this.handleFormValidation();
  }

  async textHandler(event) {
    await this.setState({
      [event.target.name]: event.detail.value,
    });

    await this.handleValidation(event);
    await this.handleFormValidation();
  }

  async toggleHandler(event) {
    await this.setState({
      [event.target.name]: event.detail.checked,
    });

    await this.handleFormValidation();
  }

  async handleValidation(event) {
    let errors = {};
    let error = false;

    if (event.target && event.target.firstChild && event.target.firstChild.validationMessage) {
      error = event.target.firstChild.validationMessage;
    }

    if (event.firstChild && event.firstChild.validationMessage) {
      error = event.firstChild.validationMessage;
    }

    let name = !!event.target ? event.target.name : event.name;
    delete errors[name];
    if (error) errors[name] = error;
    await this.setState({ errors });
  }

  async handleFormValidation() {
    let errors = this.state.errors;

    delete errors['codice_fiscale'];
    if (!this.state.codice_fiscale) {
      errors['codice_fiscale'] = 'Selezionare un codice fiscale.';
    }

    let valid = this.form.current ? this.form.current.checkValidity() : true;
    this.setState({
      errors,
      disabled: !valid || !this.state.codice_fiscale,
    });

    return !valid || !this.state.codice_fiscale;
  }

  async setFiscalCode(event) {
    if (!!!event.detail.checked) return;

    try {
      let fiscalcode = event.target.value;
      await this.setState({ codice_fiscale: fiscalcode });
    } catch (error) {
      console.error(error);
    } finally {
      await this.setState({ fiscalcodeModal: false });
      this.handleFormValidation();
    }
  }

  async submitRequest(e) {
    e.preventDefault();
    if (!this.handleFormValidation()) return;
    if (!!!this.state.codice_fiscale) {
      if (this.props.toast && this.props.toast.current) {
        this.props.toast.current.add({
          message: 'Selezionare un codice fiscale',
          color: 'warning',
        });
      }

      return;
    }

    try {
      if (this.props.loader && this.props.loader.current) {
        this.props.loader.current.show();
      }

      this.setState({ disabled: true });

      const data = {
        type: this.state.type,
        fse_consent: this.state.fse_consent,
        nre: this.state.type === 'fse' ? null : this.state.nre,
        codice_fiscale: this.state.codice_fiscale.toUpperCase(),
        note: this.state.note,
        equivalent: this.state.equivalent,
        file: this.state.type === 'fse' ? null : this.state.files.length > 0 ? this.state.files[0] : null,
      };

      await PrescriptionRequestService.create(data);

      if (this.props.toast && this.props.toast.current) {
        this.props.toast.current.add({
          message: 'Ricetta inviata con successo',
          color: 'success',
        });
      }

      this.props.history.push('/app/prescription-request/list');
    } catch (error) {
      console.error(error);

      if (this.props.toast && this.props.toast.current) {
        this.props.toast.current.add({
          message: 'Impossibile inviare la ricetta',
          color: 'warning',
        });
      }
    } finally {
      if (this.props.loader && this.props.loader.current) {
        this.props.loader.current.dismiss();
      }

      this.setState({ disabled: false });
    }
  }

  render() {
    const { type, errors } = this.state;

    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/app/prescription-request" />
            </IonButtons>

            <IonTitle>Invia ricetta</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          <form ref={this.form} onSubmit={this.submitRequest}>
            <IonList lines="full" className="ion-no-margin ion-no-padding">
              {type === 'fse' && (
                <>
                  <p className="ion-padding-top ion-padding-start ion-padding-end">
                    Invio ricetta con Fascicolo Sanitario Elettronico
                  </p>

                  <IonItem>
                    <IonLabel color={!!errors.fse_consent ? 'danger' : null} position="" />
                    <IonToggle
                      slot="end"
                      mode="ios"
                      name="fse_consent"
                      onIonChange={this.toggleHandler}
                      checked={this.state.fse_consent}
                    />

                    <p>
                      Do il consenso per il prelievo delle ricette elettroniche presenti nel Fascicolo Sanitario
                      Elettronico
                    </p>
                  </IonItem>
                </>
              )}

              {type === 'nre' && (
                <>
                  <p className="ion-padding-top ion-padding-start ion-padding-end">
                    Invio ricetta con Numero Ricetta Elettronica
                  </p>

                  <IonItem>
                    <IonLabel color={!!errors.nre ? 'danger' : null} position="stacked">
                      Digita il numero di ricetta elettronica (NRE)
                      <IonText color="danger">*</IonText>
                    </IonLabel>

                    <IonInput
                      type="text"
                      name="nre"
                      required
                      placeholder="Esempio: 2000A1234567891234"
                      ref={this.nre}
                      minlength={13}
                      maxlength={15}
                      onIonBlur={this.handleValidation}
                      onIonChange={this.inputHandler}
                      value={this.state.nre}
                    />

                    {!!errors.nre ? <IonText color="danger">{errors.nre}</IonText> : null}
                  </IonItem>

                  <p className="ion-padding-start">Dove si trova il numero di ricetta elettronica ?</p>
                  <IonImg style={{ width: '100%', maxWidth: '500px' }} src="/assets/nre.png" />
                </>
              )}

              {type === 'file' && (
                <>
                  <p className="ion-padding-top ion-padding-start ion-padding-end">
                    Invio ricetta con caricamento file o foto
                  </p>

                  <IonItem lines="none">
                    <IonLabel color={!!errors.files ? 'danger' : null} position="">
                      <p>
                        Carica il file o scatta una foto
                        <IonText color="danger">*</IonText>
                      </p>
                    </IonLabel>
                  </IonItem>

                  <IonList>
                    {this.state.files.map((file, key) => (
                      <IonItem key={key}>
                        <IonLabel className="ion-padding-start">{file.name}</IonLabel>
                        <IonIcon icon={close} slot="end" onClick={() => this.removeFile(key)} />
                      </IonItem>
                    ))}

                    <IonItem lines={!!errors.files ? 'none' : null}>
                      <File onChange={this.fileHandler} name="files" ref={this.files} required />
                    </IonItem>

                    {!!errors.files && (
                      <IonItem>
                        <IonText color="danger">{errors.files}</IonText>
                      </IonItem>
                    )}
                  </IonList>
                </>
              )}

              <IonItem>
                <IonLabel>Farmaco equivalente</IonLabel>
                <IonToggle
                  slot="end"
                  mode="ios"
                  name="equivalent"
                  onIonChange={this.toggleHandler}
                  checked={this.state.equivalent}
                />
              </IonItem>

              <IonItem lines="full" detail onClick={() => this.setState({ fiscalcodeModal: true })}>
                {!!this.state.codice_fiscale ? (
                  <IonLabel color="default">{this.state.codice_fiscale}</IonLabel>
                ) : (
                  <IonText color={!!errors.codice_fiscale ? 'danger' : 'danger'}>Seleziona codice fiscale</IonText>
                )}
              </IonItem>

              <IonItem>
                <IonLabel position="stacked">Note aggiuntive</IonLabel>
                <IonTextarea
                  type="text"
                  name="note"
                  placeholder="Indica qui se hai preferenze o altre comunicazioni relative alla ricetta."
                  onIonChange={this.textHandler}
                  value={this.state.note}
                />
              </IonItem>

              <div className="ion-padding">
                <IonButton
                  expand="block"
                  type="submit"
                  disabled={this.state.disabled}
                  onClick={this.handleFormValidation}
                >
                  <IonIcon slot="start" icon={add} /> Invia ricetta
                </IonButton>
              </div>
            </IonList>
          </form>
        </IonContent>

        <IonModal isOpen={this.state.fiscalcodeModal} onDidDismiss={() => this.setState({ fiscalcodeModal: false })}>
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="end">
                <IonButton onClick={() => this.setState({ fiscalcodeModal: false })}>
                  <IonIcon icon={close} />
                </IonButton>
              </IonButtons>

              <IonTitle>Seleziona codice fiscale</IonTitle>
            </IonToolbar>
          </IonHeader>

          <IonContent>
            <IonList>
              {!!this.state.fiscalCodes.length ? (
                this.state.fiscalCodes.map((fiscalcode) => (
                  <IonItem key={fiscalcode.id}>
                    <IonLabel>
                      <strong>{fiscalcode.codice_fiscale}</strong>
                    </IonLabel>

                    <IonCheckbox
                      slot="start"
                      value={fiscalcode.codice_fiscale}
                      onIonChange={(e) => this.setFiscalCode(e)}
                      checked={this.state.codice_fiscale === fiscalcode.codice_fiscale}
                    />
                  </IonItem>
                ))
              ) : (
                <IonItem>
                  <IonLabel>
                    <p>Nessun codice fiscale presente</p>
                  </IonLabel>
                </IonItem>
              )}
            </IonList>
          </IonContent>

          <IonFooter className="ion-padding">
            <IonToolbar>
              <IonButton
                expand="block"
                color="light"
                onClick={() => {
                  this.setState({ fiscalcodeModal: false });
                  this.props.history.push('/app/fiscalcode?redirect=/app/prescription-request');
                }}
              >
                <IonIcon icon={add} /> Aggiungi un codice fiscale
              </IonButton>
            </IonToolbar>
          </IonFooter>
        </IonModal>
      </>
    );
  }
}

export default withIonLifeCycle(PrescriptionRequestForm);
